import React from 'react'
import MuiTooltip from '@material-ui/core/Tooltip'
import { makeStyles } from '@material-ui/core/styles'
import { useTheme } from 'styled-components'
import { Fade } from '@material-ui/core'

const DEFAULT_STYLE = {
  tooltip: {
    maxWidth: '350px',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16px',
    padding: '8px 16px'
  }
}

const StandardTooltipStyle = makeStyles(() => {
  const scTheme = useTheme()
  return {
    tooltip: {
      ...DEFAULT_STYLE.tooltip,
      fontFamily: scTheme.ds.typography.fontFamily,
      color: scTheme.ds.colors.white,
      backgroundColor: scTheme.ds.colors.neutral700,
      textAlign: 'center'
    },
    arrow: {
      color: scTheme.ds.colors.neutral700
    }
  }
})

const AlertTooltipStyle = makeStyles(() => {
  const scTheme = useTheme()
  return {
    tooltip: {
      ...DEFAULT_STYLE.tooltip,
      fontFamily: scTheme.ds.typography.fontFamily,
      color: scTheme.ds.colors.danger500,
      backgroundColor: scTheme.ds.colors.danger100,
      textAlign: 'left',
      fontWeight: 600
    },
    arrow: {
      color: scTheme.ds.colors.danger100
    }
  }
})

type Props = {
  children: React.ReactElement
  text: string | React.ReactElement
  className?: string
  placement?:
    | 'bottom'
    | 'left'
    | 'right'
    | 'top'
    | 'top-start'
    | 'bottom-end'
    | 'bottom-start'
    | 'left-end'
    | 'left-start'
    | 'right-end'
    | 'right-start'
    | 'top-end'
    | undefined
  cursor?: 'pointer' | 'default'
  type?: 'standard' | 'alert'
}

export function TooltipNew({
  children,
  text,
  placement = 'top-start',
  cursor = 'default',
  type = 'standard',
  className
}: Props) {
  const classes =
    type === 'standard' ? StandardTooltipStyle() : AlertTooltipStyle()

  return (
    <MuiTooltip
      title={text}
      style={{ cursor: cursor }}
      arrow
      placement={placement}
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 500 }}
      leaveDelay={200}
      enterDelay={100}
      className={className}
      classes={classes}
    >
      {children}
    </MuiTooltip>
  )
}
